

import React, { useState } from 'react';
import './PurchaseOrders.css';

const PurchaseOrders = () => {
  // Initial purchase orders data - 7 records with projectCreated flag
  const [purchaseOrders, setPurchaseOrders] = useState([
    {
      id: 1,
      poNo: 'PO-2025-014',
      client: 'Acme Industries',
      clientId: 'CLT-001',
      value: '₹9,20,000',
      date: '2025-04-21',
      createdBy: 'Priya (Exec)',
      document: 'PO-2025-014.pdf',
      projectCreated: true,
      projectId: 'PRJ-001',
      projectDetails: {
        name: 'Acme Digital Transformation',
        startDate: '2025-05-01',
        endDate: '2025-08-31',
        budget: '₹9,20,000',
        status: 'Active',
        description: 'Complete digital transformation project for Acme Industries'
      }
    },
    {
      id: 2,
      poNo: 'PO-2025-023',
      client: 'Nimbus Tech',
      clientId: 'CLT-002',
      value: '₹16,50,000',
      date: '2025-04-18',
      createdBy: 'Karan (Exec)',
      document: 'PO-2025-023.pdf',
      projectCreated: true,
      projectId: 'PRJ-002',
      projectDetails: {
        name: 'Nimbus Cloud Migration',
        startDate: '2025-05-10',
        endDate: '2025-09-30',
        budget: '₹16,50,000',
        status: 'Active',
        description: 'Cloud infrastructure migration project'
      }
    },
    
    {
      id: 4,
      poNo: 'PO-2025-045',
      client: 'BluePeak Foods',
      clientId: 'CLT-004',
      value: '₹7,80,000',
      date: '2025-04-10',
      createdBy: 'Karan (Exec)',
      document: 'PO-2025-045.pdf',
      projectCreated: true,
      projectId: 'PRJ-004',
      projectDetails: {
        name: 'BluePeak Supply Chain',
        startDate: '2025-05-05',
        endDate: '2025-07-31',
        budget: '₹7,80,000',
        status: 'Active',
        description: 'Supply chain optimization project'
      }
    },
    {
      id: 5,
      poNo: 'PO-2025-056',
      client: 'Stellar Solutions',
      clientId: 'CLT-005',
      value: '₹22,50,000',
      date: '2025-04-25',
      createdBy: 'Neha (Manager)',
      document: 'PO-2025-056.pdf',
      projectCreated: false,
      projectId: null,
      projectDetails: null
    },
    {
      id: 6,
      poNo: 'PO-2025-062',
      client: 'Quantum Dynamics',
      clientId: 'CLT-006',
      value: '₹31,20,000',
      date: '2025-04-28',
      createdBy: 'Raj (Sales)',
      document: 'PO-2025-062.pdf',
      projectCreated: false,
      projectId: null,
      projectDetails: null
    },
    {
      id: 7,
      poNo: 'PO-2025-078',
      client: 'Acme Industries',
      clientId: 'CLT-001',
      value: '₹5,60,000',
      date: '2025-04-30',
      createdBy: 'Priya (Exec)',
      document: 'PO-2025-078.pdf',
      projectCreated: false,
      projectId: null,
      projectDetails: null
    }
  ]);

  // Client options for dropdown
  const clientOptions = [
    { id: 'CLT-001', name: 'Acme Industries' },
    { id: 'CLT-002', name: 'Nimbus Tech' },
    { id: 'CLT-003', name: 'Orbit Logistics' },
    { id: 'CLT-004', name: 'BluePeak Foods' },
    { id: 'CLT-005', name: 'Stellar Solutions' },
    { id: 'CLT-006', name: 'Quantum Dynamics' }
  ];

  // Modal states
  const [isAddPOModalOpen, setIsAddPOModalOpen] = useState(false);
  const [isViewDocumentModalOpen, setIsViewDocumentModalOpen] = useState(false);
  const [isGenerateProjectModalOpen, setIsGenerateProjectModalOpen] = useState(false);
  const [isViewProjectModalOpen, setIsViewProjectModalOpen] = useState(false);
  const [selectedPO, setSelectedPO] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [successPOId, setSuccessPOId] = useState(null);

  // Form state for new PO
  const [formData, setFormData] = useState({
    client: '',
    poValue: '',
    dateReceived: '',
    poDocument: ''
  });

  // Project generation form state
  const [projectFormData, setProjectFormData] = useState({
    projectName: '',
    startDate: '',
    endDate: '',
    budget: '',
    status: 'Planning',
    description: ''
  });

  // Owner options
  const ownerOptions = ['Aarav (Admin)', 'Priya (Exec)', 'Karan (Exec)', 'Neha (Manager)', 'Raj (Sales)'];
  const [selectedOwner, setSelectedOwner] = useState('Aarav (Admin)');

  // Handle form input change for PO
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle project form input change
  const handleProjectInputChange = (e) => {
    const { name, value } = e.target;
    setProjectFormData(prev => ({ ...prev, [name]: value }));
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  // Format number to Indian currency format
  const formatIndianCurrency = (value) => {
    // Remove any existing ₹ symbol and commas
    let cleanValue = value.toString().replace(/[₹,]/g, '');
    // Parse as number
    const num = parseFloat(cleanValue);
    if (isNaN(num)) return value;
    // Format with Indian number system (lakhs/crores)
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0,
      style: 'currency',
      currency: 'INR'
    }).format(num);
  };

  // Generate next PO number
  const generatePONumber = () => {
    const lastPO = purchaseOrders[purchaseOrders.length - 1];
    if (lastPO) {
      const lastNumber = parseInt(lastPO.poNo.split('-')[2]);
      const nextNumber = String(lastNumber + 1).padStart(3, '0');
      return `PO-2025-${nextNumber}`;
    }
    return 'PO-2025-079';
  };

  // Validate PO value (accepts numbers with or without commas, with or without ₹)
  const validatePOValue = (value) => {
    // Remove ₹ symbol and spaces
    let cleanValue = value.toString().replace(/[₹\s]/g, '');
    // Check if it's a valid number (with or without commas)
    const numberPattern = /^(\d{1,3}(,\d{3})*|\d+)(\.\d{2})?$/;
    if (numberPattern.test(cleanValue)) {
      // Remove commas and convert to number
      const numValue = parseFloat(cleanValue.replace(/,/g, ''));
      return !isNaN(numValue) && numValue > 0;
    }
    return false;
  };

  // Add new PO (without project initially)
  const handleAddPO = () => {
    if (!formData.client || !formData.poValue || !formData.dateReceived) {
      alert('Please fill all required fields: Client, PO Value, and Date Received');
      return;
    }

    // Validate PO value
    if (!validatePOValue(formData.poValue)) {
      alert('Please enter a valid amount (e.g., 920000, 9,20,000, ₹9,20,000, or 920000.00)');
      return;
    }

    // Format value with Indian currency format
    let cleanValue = formData.poValue.toString().replace(/[₹\s]/g, '');
    let numericValue = parseFloat(cleanValue.replace(/,/g, ''));
    let formattedValue = formatIndianCurrency(numericValue);

    const selectedClient = clientOptions.find(c => c.id === formData.client);
    const newPONo = generatePONumber();

    const newPO = {
      id: purchaseOrders.length + 1,
      poNo: newPONo,
      client: selectedClient ? selectedClient.name : formData.client,
      clientId: formData.client,
      value: formattedValue,
      date: formData.dateReceived,
      createdBy: selectedOwner,
      document: formData.poDocument || `${newPONo}.pdf`,
      projectCreated: false,
      projectId: null,
      projectDetails: null
    };

    setPurchaseOrders([...purchaseOrders, newPO]);

    // Reset form
    setFormData({
      client: '',
      poValue: '',
      dateReceived: '',
      poDocument: ''
    });
    setSelectedOwner('Aarav (Admin)');

    setIsAddPOModalOpen(false);
    alert(`✅ PO ${newPONo} added successfully!\n📋 Click "Generate Project" to create a project for this PO.`);
  };

  // Open Generate Project Modal
  const openGenerateProjectModal = (po) => {
    setSelectedPO(po);
    // Pre-fill project form with PO data
    setProjectFormData({
      projectName: `${po.client} Project`,
      startDate: new Date().toISOString().split('T')[0],
      endDate: '',
      budget: po.value,
      status: 'Planning',
      description: `Project created from PO ${po.poNo} for ${po.client}`
    });
    setIsGenerateProjectModalOpen(true);
  };

  // Save Generated Project
  const handleGenerateProject = () => {
    if (!projectFormData.projectName || !projectFormData.startDate) {
      alert('Please fill Project Name and Start Date');
      return;
    }

    const updatedOrders = purchaseOrders.map(po => {
      if (po.id === selectedPO.id) {
        return {
          ...po,
          projectCreated: true,
          projectId: `PRJ-${String(po.id).padStart(3, '0')}`,
          projectDetails: {
            name: projectFormData.projectName,
            startDate: projectFormData.startDate,
            endDate: projectFormData.endDate || 'TBD',
            budget: projectFormData.budget,
            status: projectFormData.status,
            description: projectFormData.description
          }
        };
      }
      return po;
    });

    setPurchaseOrders(updatedOrders);
    setSuccessPOId(selectedPO.id);
    setSuccessMessage(`✅ Project "${projectFormData.projectName}" created successfully for ${selectedPO.poNo}!`);
    
    // Clear success message after 3 seconds
    setTimeout(() => {
      setSuccessPOId(null);
      setSuccessMessage('');
    }, 3000);
    
    setIsGenerateProjectModalOpen(false);
    setSelectedPO(null);
    setProjectFormData({
      projectName: '',
      startDate: '',
      endDate: '',
      budget: '',
      status: 'Planning',
      description: ''
    });
  };

  // View document
  const viewDocument = (po) => {
    setSelectedPO(po);
    setIsViewDocumentModalOpen(true);
  };

  // Download document (simulated)
  const downloadDocument = () => {
    alert(`📥 Downloading ${selectedPO.document}`);
  };

  // Get total PO value
  const getTotalValue = () => {
    const total = purchaseOrders.reduce((sum, po) => {
      const cleanValue = po.value.replace(/[₹,]/g, '');
      const value = parseFloat(cleanValue);
      return sum + (isNaN(value) ? 0 : value);
    }, 0);
    return formatIndianCurrency(total);
  };

  // View project details in popup
  const openViewProjectModal = (po) => {
    setSelectedPO(po);
    setIsViewProjectModalOpen(true);
  };

  return (
    <div className="po-container">
      <div className="po-wrapper">
        {/* Header Section */}
        <div className="po-header">
          <div className="po-header-top">
            <div className="po-header-left">
              <h1 className="po-title">Purchase Orders</h1>
             
            </div>
            <button className="po-add-btn" onClick={() => setIsAddPOModalOpen(true)}>
              + Log PO
            </button>
          </div>
         
        </div>

       
        {successMessage && (
          <div className="po-success-toast">
            <span className="po-success-toast-icon">✅</span>
            <span>{successMessage}</span>
          </div>
        )}

        {/* Purchase Orders Table */}
        <div className="po-table-section">
          <div className="po-table-responsive">
            <table className="po-table">
              <thead>
                <tr>
                  <th>PO #</th>
                  <th>CLIENT</th>
                  <th>VALUE</th>
                  <th>DATE</th>
                  <th>CREATED BY</th>
                  <th>DOCUMENT</th>
                  <th>PROJECT</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrders.map((po) => (
                  <tr key={po.id} className={successPOId === po.id ? 'po-row-success' : ''}>
                    <td className="po-cell-po-no">{po.poNo}</td>
                    <td>{po.client}</td>
                    <td className="po-cell-value">{po.value}</td>
                    <td>{formatDate(po.date)}</td>
                    <td>{po.createdBy}</td>
                    <td>
                      <button className="po-doc-btn" onClick={() => viewDocument(po)}>
                        📄 View Doc
                      </button>
                    </td>
                    <td>
                      {po.projectCreated ? (
                        <div className="po-project-status success">
                          <span className="po-success-tick">✓</span> Created
                          <button className="po-view-project-btn" onClick={() => openViewProjectModal(po)}>
                            View
                          </button>
                        </div>
                      ) : (
                        <div className="po-project-status pending">
                          <span className="po-pending-icon">⏳</span> Not Created
                        </div>
                      )}
                    </td>
                    <td>
                      {!po.projectCreated ? (
                        <button 
                          className="po-generate-project-btn"
                          onClick={() => openGenerateProjectModal(po)}
                        >
                           Gen-Project
                        </button>
                      ) : (
                        <button 
                          className="po-project-done-btn"
                          disabled
                        >
                          ✓ Done
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Tip Section */}
        <div className="po-tip">
          <div className="po-tip-icon">💡</div>
          <div className="po-tip-text">
            A client can have multiple POs — each can generate its own Project. 
            Click "Generate Project" to create a project from a PO. After generation, a green tick ✓ will appear.
          </div>
        </div>
      </div>

      {/* Add PO Modal */}
      {isAddPOModalOpen && (
        <div className="po-modal-overlay" onClick={() => setIsAddPOModalOpen(false)}>
          <div className="po-modal" onClick={(e) => e.stopPropagation()}>
            <div className="po-modal-header">
              <h3>📝 Log Purchase Order</h3>
              <button className="po-modal-close" onClick={() => setIsAddPOModalOpen(false)}>×</button>
            </div>
            <div className="po-modal-body">
              <div className="po-form-group">
                <label>Client <span className="po-required">*</span></label>
                <select name="client" value={formData.client} onChange={handleInputChange}>
                  <option value="">Select a client</option>
                  {clientOptions.map(client => (
                    <option key={client.id} value={client.id}>
                      {client.name} ({client.id})
                    </option>
                  ))}
                </select>
              </div>

              <div className="po-form-group">
                <label>PO Value <span className="po-required">*</span></label>
                <input
                  type="text"
                  name="poValue"
                  value={formData.poValue}
                  onChange={handleInputChange}
                  placeholder="e.g., 920000, 9,20,000, or ₹9,20,000"
                />
                <small className="po-hint">Enter amount (supports: 920000, 9,20,000, ₹9,20,000)</small>
              </div>

              <div className="po-form-group">
                <label>Date Received <span className="po-required">*</span></label>
                <input
                  type="date"
                  name="dateReceived"
                  value={formData.dateReceived}
                  onChange={handleInputChange}
                />
              </div>

              <div className="po-form-group">
                <label>Created By</label>
                <select value={selectedOwner} onChange={(e) => setSelectedOwner(e.target.value)}>
                  {ownerOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
              </div>

              <div className="po-form-group">
                <label>PO Document</label>
                <input
                  type="text"
                  name="poDocument"
                  value={formData.poDocument}
                  onChange={handleInputChange}
                  placeholder="po-2025-099.pdf"
                />
                <small className="po-hint">Enter filename or leave empty for auto-generated name</small>
              </div>
            </div>
            <div className="po-modal-footer">
              <button className="po-cancel-button" onClick={() => setIsAddPOModalOpen(false)}>Cancel</button>
              <button className="po-save-button" onClick={handleAddPO}>Save PO</button>
            </div>
          </div>
        </div>
      )}

      {/* Generate Project Modal */}
      {isGenerateProjectModalOpen && selectedPO && (
        <div className="po-modal-overlay" onClick={() => setIsGenerateProjectModalOpen(false)}>
          <div className="po-modal po-project-modal" onClick={(e) => e.stopPropagation()}>
            <div className="po-modal-header">
              <h3>🚀 Generate Project for {selectedPO.poNo}</h3>
              <button className="po-modal-close" onClick={() => setIsGenerateProjectModalOpen(false)}>×</button>
            </div>
            <div className="po-modal-body">
              <div className="po-project-info-bar">
                <div><strong>🏢 Client:</strong> {selectedPO.client}</div>
                <div><strong>💰 PO Value:</strong> {selectedPO.value}</div>
                <div><strong>📅 Date Received:</strong> {formatDate(selectedPO.date)}</div>
              </div>
              
              <div className="po-form-group">
                <label>Project Name <span className="po-required">*</span></label>
                <input
                  type="text"
                  name="projectName"
                  value={projectFormData.projectName}
                  onChange={handleProjectInputChange}
                  placeholder="Enter project name"
                />
              </div>

              <div className="po-form-row">
                <div className="po-form-group">
                  <label>Start Date <span className="po-required">*</span></label>
                  <input
                    type="date"
                    name="startDate"
                    value={projectFormData.startDate}
                    onChange={handleProjectInputChange}
                  />
                </div>
                <div className="po-form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={projectFormData.endDate}
                    onChange={handleProjectInputChange}
                  />
                </div>
              </div>

              <div className="po-form-row">
                <div className="po-form-group">
                  <label>Budget</label>
                  <input
                    type="text"
                    name="budget"
                    value={projectFormData.budget}
                    onChange={handleProjectInputChange}
                    placeholder="Project budget"
                  />
                </div>
                <div className="po-form-group">
                  <label>Status</label>
                  <select name="status" value={projectFormData.status} onChange={handleProjectInputChange}>
                    <option value="Planning">📝 Planning</option>
                    <option value="Active">🚀 Active</option>
                    <option value="On Hold">⏸️ On Hold</option>
                    <option value="Completed">✅ Completed</option>
                  </select>
                </div>
              </div>

              <div className="po-form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={projectFormData.description}
                  onChange={handleProjectInputChange}
                  rows="3"
                  placeholder="Project description"
                ></textarea>
              </div>
            </div>
            <div className="po-modal-footer">
              <button className="po-cancel-button" onClick={() => setIsGenerateProjectModalOpen(false)}>Cancel</button>
              <button className="po-generate-save-button" onClick={handleGenerateProject}>
                ✅ Create Project
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Project Details Modal */}
      {isViewProjectModalOpen && selectedPO && selectedPO.projectDetails && (
        <div className="po-modal-overlay" onClick={() => setIsViewProjectModalOpen(false)}>
          <div className="po-modal po-view-project-modal" onClick={(e) => e.stopPropagation()}>
            <div className="po-modal-header">
              <h3>📊 Project Details</h3>
              <button className="po-modal-close" onClick={() => setIsViewProjectModalOpen(false)}>×</button>
            </div>
            <div className="po-modal-body">
              <div className="po-view-project-content">
                <div className="po-view-project-header">
                  <div className="po-project-icon-large">🚀</div>
                  <div>
                    <h2>{selectedPO.projectDetails.name}</h2>
                    <p className="po-project-subtitle">Project ID: {selectedPO.projectId}</p>
                  </div>
                </div>
                
                <div className="po-view-project-info">
                  <div className="po-info-row">
                    <div className="po-info-label">PO Reference:</div>
                    <div className="po-info-value">{selectedPO.poNo}</div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Client:</div>
                    <div className="po-info-value">{selectedPO.client}</div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Project Status:</div>
                    <div className="po-info-value">
                      <span className={`po-status-badge po-status-${selectedPO.projectDetails.status.toLowerCase().replace(' ', '')}`}>
                        {selectedPO.projectDetails.status}
                      </span>
                    </div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Timeline:</div>
                    <div className="po-info-value">
                      {formatDate(selectedPO.projectDetails.startDate)} → {selectedPO.projectDetails.endDate !== 'TBD' ? formatDate(selectedPO.projectDetails.endDate) : 'TBD'}
                    </div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Budget:</div>
                    <div className="po-info-value po-budget-value">{selectedPO.projectDetails.budget}</div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Created By:</div>
                    <div className="po-info-value">{selectedPO.createdBy}</div>
                  </div>
                  <div className="po-info-row">
                    <div className="po-info-label">Description:</div>
                    <div className="po-info-value po-description-text">{selectedPO.projectDetails.description}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="po-modal-footer">
              <button className="po-cancel-button" onClick={() => setIsViewProjectModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* View Document Modal */}
      {isViewDocumentModalOpen && selectedPO && (
        <div className="po-modal-overlay" onClick={() => setIsViewDocumentModalOpen(false)}>
          <div className="po-modal po-doc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="po-modal-header">
              <h3>📄 PO Document - {selectedPO.poNo}</h3>
              <button className="po-modal-close" onClick={() => setIsViewDocumentModalOpen(false)}>×</button>
            </div>
            <div className="po-modal-body">
              <div className="po-doc-preview">
                <div className="po-doc-icon">📄</div>
                <div className="po-doc-name">{selectedPO.document}</div>
                <div className="po-doc-details">
                  <div><strong>PO #:</strong> {selectedPO.poNo}</div>
                  <div><strong>Client:</strong> {selectedPO.client}</div>
                  <div><strong>Value:</strong> {selectedPO.value}</div>
                  <div><strong>Date:</strong> {formatDate(selectedPO.date)}</div>
                  <div><strong>Created By:</strong> {selectedPO.createdBy}</div>
                </div>
              </div>
            </div>
            <div className="po-modal-footer">
              <button className="po-cancel-button" onClick={() => setIsViewDocumentModalOpen(false)}>Close</button>
              <button className="po-download-button" onClick={downloadDocument}>📥 Download</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseOrders;